import { render, staticRenderFns } from "./PXWCILMD.vue?vue&type=template&id=8b086edc&scoped=true&"
import script from "./PXWCILMD.vue?vue&type=script&lang=js&"
export * from "./PXWCILMD.vue?vue&type=script&lang=js&"
import style0 from "./PXWCILMD.vue?vue&type=style&index=0&id=8b086edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b086edc",
  null
  
)

export default component.exports